<script lang="ts" setup>
import { Document } from '@contentful/rich-text-types'
type BrillianceSignupProps = {
  signUpPanel?: Document
}
defineProps<BrillianceSignupProps>()
const uiStore = useUIStore()
const preferencesStore = usePreferencesStore()
</script>

<template>
  <div class="footer__brilliance-signup">
    <h2 class="footer__brilliance-signup-title">{{ $t('footer.brilliance_signup.title') }}</h2>
    <!-- @vue-skip -->
    <RichTextPanel v-bind="{ ...signUpPanel }" skip-container />
    <form
      id="footer__brilliance-signup"
      class="footer__brilliance-signup-form"
      method="post"
      @submit.prevent="uiStore.isShowSignUpModal = true"
    >
      <input
        v-model="uiStore.loginEmail"
        id="signup-email"
        ref="email"
        type="text"
        name="brillianceSignupFooterEmail"
        class="footer__brilliance-signup-input"
        :placeholder="$t('footer.brilliance_signup.input_placeholder')"
        aria-label="signup-email-input"
      />
      <button class="footer__brilliance-signup-button button-secondary" type="submit">
        {{ $t('footer.brilliance_signup.button_submit') }}
      </button>
    </form>
  </div>
</template>

<style scoped lang="postcss">
.footer__brilliance-signup {
  padding-bottom: 1rem;
  width: 100%;

  @media (--tablet) {
    max-width: 26rem;
    min-width: 3.75rem;
  }
  @media (--desktop) {
    width: 26rem;
  }

  .footer__brilliance-signup-description {
    margin-bottom: 1.5rem;
  }

  .footer__brilliance-signup-form {
    display: flex;
    height: 3rem;
    width: 100%;

    .footer__brilliance-signup-input {
      padding: 0.5rem;
      position: relative;
      width: 100%;
      border-radius: 2.5px;
      border: 1px solid #767676;

      @media (--mobile-tablet-only) {
        font-size: var(--space-50); /* Avoid iOS zoom min font size */
      }
    }

    .footer__brilliance-signup-button {
      min-width: fit-content;
      margin-left: -1px;
      padding: 0 2rem;
      z-index: 1;
    }
  }
}
</style>
